import { defineMessage } from 'react-intl';

export const similarProductsFallbackHeadline = defineMessage({
  id: 'rde.alternative-products.headline-fallback',
  defaultMessage: 'Ähnliche Artikel',
});
